import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import {
    formatIcon,
} from './helpers/format-icon';
import {
    formatIconClassName,
} from './helpers/format-icon-class-name';

import gotoImage from './media/goto.svg';

import styles from './DeepLinkButton.module.scss';

const DeepLinkButton: FC<IProps> = (props) => {
    return (
        <a
            className={classNames(styles.deepLinkButton, props.className)}
            href={props.value}
        >
            <img
                className={formatIconClassName(props.type)}
                src={formatIcon(props.type)}
                alt={props.type}
            />
            <img
                className={styles.gotoImage}
                src={gotoImage}
                alt={'Go to'}
            />
        </a>
    );
};

export default DeepLinkButton;
